// extracted by mini-css-extract-plugin
module.exports = {"total-row":"PolePriceRows_total-row__1n4_l"};